// app.js

// Регистрация Service Worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(new URL('./service-worker.js', import.meta.url))
            .then(registration => {
                console.log('ServiceWorker зарегистрирован с областью:', registration.scope);
            })
            .catch(error => {
                console.log('Ошибка регистрации ServiceWorker:', error);
            });
    });
}

// Обработка кнопок
document.addEventListener('DOMContentLoaded', () => {
    const gateBtn = document.getElementById('gateBtn');
    const barrier1Btn = document.getElementById('barrier1Btn');
    const barrier2Btn = document.getElementById('barrier2Btn');

    // URL-адреса для запросов (замените на ваши реальные конечные точки)
    const gatePhone = '+79186893480';
    const barrier1Phone = '+79186893482';
    const barrier2Phone = '+79186893484';
    const url = 'https://gates-pwa.vipcrm.ru/api/gate/'
    const token = 'c8f83b32d51284dbedb745d178c1270a'

    // Функция для отправки запроса
// Функция для отправки запроса
    const sendRequest = (url, phone) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "callto": phone,
                "token": token
            })
        })
            .then(response => {
                const statusMessage = document.getElementById('statusMessage');
                if (response.ok) {
                    statusMessage.textContent = 'Команда отправлена успешно!';
                    statusMessage.style.color = 'green'; // Успешное сообщение
                } else {
                    statusMessage.textContent = 'Ошибка при отправке команды.';
                    statusMessage.style.color = 'red'; // Ошибка
                }
            })
            .catch(error => {
                console.error('Ошибка:', error);
                const statusMessage = document.getElementById('statusMessage');
                statusMessage.textContent = 'Произошла ошибка при отправке запроса.';
                statusMessage.style.color = 'red'; // Ошибка
            });
    };

    // Обработчики событий для кнопок
    gateBtn.addEventListener('click', () => {
        sendRequest(url, gatePhone);
    });

    barrier1Btn.addEventListener('click', () => {
        sendRequest(url, barrier1Phone);
    });

    barrier2Btn.addEventListener('click', () => {
        sendRequest(url, barrier2Phone);
    });
});